import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Offer } from 'app/services/offers/offer.model';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Store } from '@ngxs/store';
import { UpdateOfferOptionTerms } from 'ng2-app/store/offers/offer-options.actions';

@Component({
  selector: 'app-offer-option-edit-modal',
  templateUrl: './offer-option-edit-modal.component.html',
  styleUrls: ['./offer-option-edit-modal.component.scss']
})
export class OfferOptionEditModalComponent implements OnInit {

  editApprovalData: any;
  initializeModalCalculator: boolean = false;

  @Input() optionParent: Approval | Offer;
  @Input() optionParentName: string;
  @Input() optionType: string;
  @Input() option: OfferOption;

  @Output() offerOptionUpdated = new EventEmitter<object>();

  approvalCalculatorData: object;

  @ViewChild('approvalModal', { static: true }) private approvalModal: ModalDirective;
  @ViewChild('offerModal', { static: true }) private offerModal: ModalDirective;

  

  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void { }

  openModal() {
    if(this.optionType === 'approval'){
      this.editApprovalData = {
        term: this.option.termSet.term,
        paymentFrequency: this.option.termSet.paymentFrequency,
        points: this.option.termSet.points,
        amount: this.option.termSet.amount,
        originationPercent: this.option.termSet.originationFeePercent,
        factorRate: this.option.termSet.factorRate,
        paymentCount: this.option.termSet.paymentCount,
        paymentAmount: this.option.termSet.paymentAmount,
        payback: this.option.termSet.payback,
        originationAmount: this.option.termSet.originationFeeAmount,
        disbursement: this.option.termSet.disbursement,
        commission: this.option.termSet.commission
      };
      this.initializeModalCalculator = true;
      this.approvalModal.show();
    }
    if(this.optionType === 'offer'){
      this.offerModal.show();
    }
  }

  closeModal() {
    this.approvalModal.hide();
    this.offerModal.hide();
  }

  onApprovalModalHide() {
    this.initializeModalCalculator = false;
    this.editApprovalData = {};
  }

  handleCalculationUpdate($event){
    this.approvalCalculatorData = $event;
  }

  saveOption(optionType){
    let termSetData;
    if(optionType === 'approval'){
      if(!!this.approvalCalculatorData){
        termSetData = this.approvalCalculatorData;
        this.store.dispatch( new UpdateOfferOptionTerms(this.option.dealId, this.option.id, termSetData) );
        this.offerOptionUpdated.emit(termSetData);
        this.closeModal();
      }
    }
  }

}
